export const pages = {
	'about': { id: 'about', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'group': { id: 'group', page: 'hub', getter: () => import(/* webpackChunkName: 'hub' */ 'components/bolt/hub/hub') },
	'events': { id: 'events', page: 'filmPage', getter: () => import(/* webpackChunkName: 'filmPage' */ 'components/bolt/filmPage/filmPage') },
	'signUp': { id: 'signUp', page: 'iframe', getter: () => import(/* webpackChunkName: 'iframe' */ 'components/bolt/iframe/iframe') },
	'landingPage': { id: 'landingPage', page: 'hub', getter: () => import(/* webpackChunkName: 'hub' */ 'components/bolt/hub/hub') },
	'privacyPolicy': { id: 'privacyPolicy', page: 'text', getter: () => import(/* webpackChunkName: 'text' */ 'components/bolt/text/text') },
	'exhibitorPortal': { id: 'exhibitorPortal', page: 'password', getter: () => import(/* webpackChunkName: 'password' */ 'components/bolt/password/password') }
};
export const sections = [
	{ id: 'about', getter: () => import(/* webpackChunkName: "toutVertical" */ 'components/bolt/toutVertical/toutVertical'), component: 'toutVertical', parent: 'about' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
